import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let appRouter = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import("./components/entrance_package/EntrancePackageList.vue")
    },
    {
      path: process.env.VUE_APP_ENTRANCEPACKAGE_PATH,
      name: "entrance-package",
      component: () =>
        import("./components/entrance_package/EntrancePackageList.vue")
    },
    {
      path: process.env.VUE_APP_ENTRANCEPACKAGE_PATH + "/add",
      name: "add-entrance-package",
      component: () =>
        import("./components/entrance_package/EntrancePackageAdd.vue")
    },
    {
      path:
        process.env.VUE_APP_ENTRANCEPACKAGE_PATH +
        "/edit/:id/:success_addition_message?",
      name: "edit-entrance-package",
      component: () =>
        import("./components/entrance_package/EntrancePackageEdit.vue")
    },
    {
      path: process.env.VUE_APP_ENTRANCEPACKAGE_PATH + "/detail/:id",
      name: "detail-entrance-package",
      component: () =>
        import("./components/entrance_package/EntrancePackageEdit.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_PATH,
      name: "attraction",
      component: () => import("./components/attraction/AttractionList.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_PATH + "/add",
      name: "add-attraction",
      component: () => import("./components/attraction/AttractionAdd.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_PATH + "/edit/:id",
      name: "edit-attraction",
      component: () => import("./components/attraction/AttractionEdit.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_SPECIALPRICE_PATH,
      name: "attraction-special-price",
      component: () =>
        import("./components/attraction/AttractionSpecialPriceList.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_SPECIALPRICE_PATH + "/add",
      name: "add-attraction-special-price",
      component: () =>
        import("./components/attraction/AttractionSpecialPriceAdd.vue")
    },
    {
      path: process.env.VUE_APP_ATTRACTION_SPECIALPRICE_PATH + "/edit/:id",
      name: "edit-attraction-special-price",
      component: () =>
        import("./components/attraction/AttractionSpecialPriceEdit.vue")
    },
    {
      path: process.env.VUE_APP_MEMBER_PATH,
      name: "member",
      component: () => import("./components/member/MemberList.vue")
    },
    {
      path: process.env.VUE_APP_MEMBER_PATH + "/add",
      name: "add-member",
      component: () => import("./components/member/MemberAdd.vue")
    },
    {
      path: process.env.VUE_APP_MEMBER_PATH + "/edit/:id",
      name: "edit-member",
      component: () => import("./components/member/MemberEdit.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIP_PATH,
      name: "membership",
      component: () => import("./components/membership/MembershipList.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIP_PATH + "/add",
      name: "add-membership",
      component: () => import("./components/membership/MembershipAdd.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIP_PATH + "/edit/:id",
      name: "edit-membership",
      component: () => import("./components/membership/MembershipEdit.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIPCLASS_PATH,
      name: "membership-class",
      component: () =>
        import("./components/membership_class/MembershipClassList.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIPCLASS_PATH + "/add",
      name: "add-membership-class",
      component: () =>
        import("./components/membership_class/MembershipClassAdd.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIPCLASS_PATH + "/edit/:id",
      name: "edit-membership-class",
      component: () =>
        import("./components/membership_class/MembershipClassEdit.vue")
    },
    {
      path: process.env.VUE_APP_MEMBERSHIPPRIVILEGE_UI_PATH,
      name: "membership-privilege",
      component: () =>
        import("./components/membership_class/MembershipPrivilegeList.vue")
    },
    {
      path:
        process.env.VUE_APP_MEMBERSHIPPRIVILEGE_UI_PATH +
        "/edit/:id/:privilegeName",
      name: "edit-membership-privilege",
      component: () =>
        import("./components/membership_class/MembershipPrivilegeEdit.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_PATH,
      name: "outlet",
      component: () => import("./components/outlet/OutletList.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_PATH + "/add",
      name: "add-outlet",
      component: () => import("./components/outlet/OutletAdd.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_PATH + "/edit/:id",
      name: "edit-outlet",
      component: () => import("./components/outlet/OutletEdit.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_ITEM_PATH,
      name: "outlet-item",
      component: () => import("./components/outlet/OutletItemList.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_ITEM_PATH + "/import",
      name: "import-outlet-item",
      component: () => import("./components/outlet/OutletItemImport.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_ITEM_PATH + "/add",
      name: "add-outlet-item",
      component: () => import("./components/outlet/OutletItemAdd.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_ITEM_PATH + "/edit/:id",
      name: "edit-outlet-item",
      component: () => import("./components/outlet/OutletItemEdit.vue")
    },
    {
      path: process.env.VUE_APP_OUTLET_ITEM_PATH + "/adjuststock/:id",
      name: "adjust-outlet-item-stock",
      component: () =>
        import("./components/outlet/OutletItemStockAdjustment.vue")
    },
    {
      path: process.env.VUE_APP_CARD_PATH,
      name: "card",
      component: () => import("./components/card/CardList.vue")
    },
    {
      path: process.env.VUE_APP_CARD_PATH + "/add",
      name: "add-card",
      component: () => import("./components/card/CardAdd.vue")
    },
    {
      path: process.env.VUE_APP_CARD_PATH + "/edit/:id",
      name: "edit-card",
      component: () => import("./components/card/CardEdit.vue")
    },
    {
      path: process.env.VUE_APP_TERMINAL_PATH,
      name: "terminal",
      component: () => import("./components/terminal/TerminalList.vue")
    },
    {
      path: process.env.VUE_APP_TERMINAL_PATH + "/add",
      name: "add-terminal",
      component: () => import("./components/terminal/TerminalAdd.vue")
    },
    {
      path: process.env.VUE_APP_TERMINAL_PATH + "/edit/:id",
      name: "edit-terminal",
      component: () => import("./components/terminal/TerminalEdit.vue")
    },
    {
      path: process.env.VUE_APP_PARKING_PATH,
      name: "parking",
      component: () => import("./components/parking/ParkingTicketList.vue")
    },
    {
      path: process.env.VUE_APP_PARKING_PATH + "/add",
      name: "add-parking",
      component: () => import("./components/parking/ParkingTicketAdd.vue")
    },
    {
      path: process.env.VUE_APP_PARKING_PATH + "/edit/:id",
      name: "edit-parking",
      component: () => import("./components/parking/ParkingTicketEdit.vue")
    },
    {
      path: process.env.VUE_APP_REPORTSALES_PATH,
      name: "report-sales",
      component: () => import("./components/report/ReportSales.vue")
    },
    {
      path: process.env.VUE_APP_REPORTSTOCK_PATH,
      name: "report-stock",
      component: () => import("./components/report/ReportStock.vue")
    },
    {
      path: process.env.VUE_APP_REPORTMEMBER_PATH,
      name: "report-member",
      component: () => import("./components/report/ReportMember.vue")
    },
    {
      path: process.env.VUE_APP_REPORTCARD_PATH,
      name: "report-card",
      component: () => import("./components/report/ReportCard.vue")
    },
    {
      path: process.env.VUE_APP_REPORTTOPUP_PATH,
      name: "report-topup",
      component: () => import("./components/report/ReportTopup.vue")
    },
    {
      path: process.env.VUE_APP_REPORTREFUND_PATH,
      name: "report-refund",
      component: () => import("./components/report/ReportRefund.vue")
    }
  ]
});

appRouter.beforeEach((to, from, next) => {
  let keycloak = Vue.prototype.$keycloak;
  if (keycloak) {
    guardWithKeycloak(keycloak, to, next);
  } else {
    next(false);
  }
});

function filterRouteWithRole(roles, to) {
  let defaultRoles = {
    admin: "ADMIN",
    superadmin: "SUPERADMIN",
    supervisor: "SUPERVISOR",
    operator: "OPERATOR",
    finance: "FINANCE",
    visitor: "VISITOR"
  };
  if (
    roles.includes(defaultRoles.operator) ||
    roles.includes(defaultRoles.visitor)
  ) {
    return false;
  }
  if (to.name && to.name.includes("home")) {
    return true;
  }
  if (to.name.includes("entrance-package")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (to.name.includes("attraction")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (
    to.name.includes("membership-class") ||
    to.name.includes("membership-privilege")
  ) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (to.name.includes("member")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin) ||
      roles.includes(defaultRoles.supervisor)
    );
  }
  if (to.name.includes("outlet")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (to.name.includes("card")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (to.name.includes("terminal")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin) ||
      roles.includes(defaultRoles.supervisor)
    );
  }
  if (to.name.includes("parking")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin)
    );
  }
  if (to.name.includes("report")) {
    return (
      roles.includes(defaultRoles.admin) ||
      roles.includes(defaultRoles.superadmin) ||
      roles.includes(defaultRoles.finance)
    );
  }
  return false;
}

function determineHomePage(roles, next) {
  let defaultRoles = {
    admin: "ADMIN",
    superadmin: "SUPERADMIN",
    supervisor: "SUPERVISOR",
    operator: "OPERATOR",
    finance: "FINANCE"
  };
  if (roles.includes(defaultRoles.finance)) {
    next({ name: "report" });
  } else if (roles.includes(defaultRoles.supervisor)) {
    next({ name: "membership" });
  } else if (
    roles.includes(defaultRoles.admin) ||
    roles.includes(defaultRoles.superadmin)
  ) {
    next({ name: "entrance-package" });
  } else {
    next(false);
  }
}

function storeTokens(keycloak) {
  localStorage.setItem("krj-token", keycloak.token);
  localStorage.setItem("krj-refresh-token", keycloak.refreshToken);
}

function logoutAndRedirectToHome(keycloak) {
  let logoutRedirectUri = process.env.VUE_APP_WEB_UI;
  keycloak.logout({ redirectUri: logoutRedirectUri });
}

function guardWithKeycloak(keycloak, to, next) {
  keycloak
    .updateToken()
    .success(function(refreshed) {
      if (refreshed) {
        storeTokens(keycloak);
      }
      if (to.name === "home") {
        determineHomePage(keycloak.realmAccess.roles, next);
        return;
      }
      if (filterRouteWithRole(keycloak.realmAccess.roles, to)) {
        next();
      } else {
        keycloak.clearToken();
        logoutAndRedirectToHome(keycloak);
      }
    })
    .error(function() {
      keycloak.clearToken();
      keycloak.logout();
    });
}

export default appRouter;
